import { Component, Input, Output, EventEmitter } from '@angular/core';
import { LanguageManagementService } from 'src/service/language-management.service';
import { FocusInputType, LocalService, LookupType, Wrappers10 } from 'src/service/local.service';
import { LookupService } from 'src/service/lookup.service';

@Component({
  selector: 'app-lookup',
  templateUrl: './lookup.component.html',
  styleUrl: './lookup.component.scss'
})
export class LookupComponent {
  LookupType = LookupType;
  lstSectionConfigKeys: string[] = ["common", "table", "lookup", "paging"];

  @Input() lookupType: LookupType = LookupType.None;
  @Input() searchKey: string = ''; isSearchKeyChanged = false;
  @Output() searchKeyChange = new EventEmitter();
  @Input() isOpen: boolean = false;
  @Output() isOpenChange = new EventEmitter();
  @Output() onClose = new EventEmitter();
  @Output() onSelect = new EventEmitter();
  @Input() selectedValue: string = '';
  @Output() selectedValueChange = new EventEmitter();

  source: Wrappers10;
  selectedLookUpName: string = 'Lookup';
  pageNameId = '_lookup_';
  elementIds: any = {
    search: 'txt' + this.pageNameId + 'search'
  };

  constructor(public localService: LocalService, private lookupService: LookupService, private languageManagementService: LanguageManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
  }

  ngOnChanges(): void {
    if (this.isOpen) {
      this.onInitiate();
    }
  }

  onInitiate() {
    this.setLookUpName();
    if (this.selectedValue) {
      this.searchKey = this.selectedValue;
    }
    this.onLoad(true);
  }

  onAction(index: number, key: string = '') {
    switch (index) {
      case 1: {
        this.onDismiss();
      } break;
      case 2: {
        this.selectedValue = key;
        this.onSetSelectedItem();
        this.onSelect.emit(this.selectedValue);
        this.onDismiss();
      } break;
      case 3: {
        this.source.paging.currentPage = this.source.paging.currentPage - 1;
        this.onAction(5);
      } break;
      case 4: {
        this.source.paging.currentPage = this.source.paging.currentPage + 1;
        this.onAction(5);
      } break;
      case 5: {
        //Refresh
        this.isSearchKeyChanged = false;
        this.onLoad();
      } break;
      case 6: {
        //Refresh with focus
        this.isSearchKeyChanged = false;
        this.onLoad(true);
      } break;
    }
  }

  setLookUpName() {
    if (this.lookupType != LookupType.None && this.localService.lookupTypes.length > 0) {
      const item = this.localService.lookupTypes.find(x => x.key == this.lookupType.toString());
      this.selectedLookUpName = item ? item.value : '-';
    }
  }

  onDismiss() {
    this.onReset();
    this.isOpen = false;
    this.onClose.emit(this.isOpen);
  }

  onLoad(isFocus = false) {
    if (this.lookupType != LookupType.None) {
      if (!this.isSearchKeyChanged) {
        this.lookupService.getLookups(this.lookupType, this.source && this.source.paging ? this.source.paging : undefined, true, this.searchKey).subscribe(result => {
          this.source = result;
          if (this.searchKey) {
            this.isSearchKeyChanged = true;
            this.source.paging.searchKey = this.searchKey;
            this.searchKey = '';
            this.searchKeyChange.emit(this.searchKey);
          }
          if (isFocus) {
            setTimeout(() => {
              this.localService.onFocusNextInput(this.elementIds.search, FocusInputType.TextBox);
            }, 100);
          }
          this.onSetSelectedItem();
        });
      } else {
        this.isSearchKeyChanged = false;
      }
    }
  }

  onSetSelectedItem() {
    let itemBefore = this.source.items.find(x => x.isSelected == true);
    if (itemBefore) {
      itemBefore.isSelected = false;
    }
    let item = this.source.items.find(x => x.v1 == this.selectedValue);
    if (item) {
      item.isSelected = true;
    }
  }

  onReset() {
    this.selectedValue = '';
    this.isSearchKeyChanged = false;
    this.source = undefined;
    this.searchKey = '';
  }
}
